<edl-authenticated [canMinimize]="false">
    <banner></banner>
</edl-authenticated>